import { format as formatDate } from 'date-fns';
import { FORMAT, format } from 'utils/date';
import { formatSlotTime } from 'utils/format-slot-time';

const formatSlotButtonText = ({ isSlotBooked, slotDate, shortTime } = {}) => {
  if (isSlotBooked && slotDate) {
    let formattedData = `${format(slotDate, FORMAT.SHORT_2DAY_MONTH)}`;

    if (shortTime) {
      formattedData = `${format(slotDate, FORMAT?.SHORT_DAY)}`;
    }

    return formattedData;
  }
  return 'Book a slot';
};

const formatSlotButtonScreenReaderLabel = ({
  isSlotBooked,
  slotEndDateTime,
  slotStartDateTime,
  slotType,
} = {}) => {
  if (isSlotBooked && slotStartDateTime && slotEndDateTime && slotType) {
    const slotTypeText = slotType.includes('COLLECTION') ? 'Collection' : 'Delivery';
    const longDateText = `${formatDate(slotStartDateTime, 'eeee')} ${formatDate(
      slotStartDateTime,
      'dd',
    )} ${format(slotStartDateTime, 'MMMM')}`;
    const longTimeText = `${formatSlotTime(slotStartDateTime)}-${formatSlotTime(slotEndDateTime)}`;

    return `${slotTypeText} slot booked for ${longDateText} ${longTimeText}. Change slot.`;
  }
  return 'Book a slot';
};

export { formatSlotButtonText, formatSlotButtonScreenReaderLabel };
